import Base from 'app/views/base';

import tmpl from 'templates/carrier_accounts_page';

import CarrierAccounts from 'app/collections/carrier_accounts';
import CarrierTypes from 'app/collections/carrier_types';

import CarrierAccountListView from 'app/views/carrier_account_list_view';
import CarrierTypeFilterView from 'app/views/carrier_type_filter_view';
import CarrierTypeListView from 'app/views/carrier_type_list_view';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'carrier-account-page',

  events: {},

  initialize() {
    this.collection = new CarrierAccounts([]);
    this.availableCarrierTypes = new CarrierTypes([]);

    this.addSubview('carrierAccountList', '#carrier_account_list', new CarrierAccountListView({ collection: this.collection }));
    this.addSubview('carrierTypeFilter', '#carrier_type_filter', new CarrierTypeFilterView({ collection: this.availableCarrierTypes }));
    this.addSubview('carrierTypeList', '#carrier_type_list', new CarrierTypeListView({
      collection: this.availableCarrierTypes,
      carrierAccounts: this.collection,
    }));

    this.listenTo(this.collection, 'sync', this.refetchCarrierTypes);
    this.listenTo(this.collection, 'remove', this.refetchCarrierTypes);
    this.collection.fetch({ reset: true });
  },

  refetchCarrierTypes() {
    this.availableCarrierTypes.fetch({ reset: true });
  },
});



// WEBPACK FOOTER //
// ./app/views/carrier_accounts_page.js